export default __webpack_public_path__ + "static/media/eAudioBooks.08c8c878.png";